module.exports = __webpack_public_path__ + "8e6670c4cd5cf9bec538d3e5d30059c0.MP3";